import { combineEpics } from 'redux-observable';
import { concat, forkJoin, of } from 'rxjs';
import { mergeMap, switchMap } from 'rxjs/operators';

import { SBL_4832_EXPIRED_MEMBERSHIP_ACCESS } from '@config';
import {
  FETCH_RELATED_CHILREN,
  continueLogin,
  triggerAllRostersRequest,
} from '@shared/duck/actions';
import { catchAndReport } from '@utils/rxjs/operators';

import { adultPositionsForParticipant } from '../constants';
import {
  getOrganizationsFromChildren,
  removeEmptyOrganizations,
  removeParentGuardiansFromOrganizations,
} from '../utils';
import { addChildren } from './actions';
import services from './services';

// Before the app is ready, we start fetching all the information from that parentGuardian to display valid information in the context tab;
const fetchRelatedChildrenEpic$ = action$ =>
  action$.ofType(FETCH_RELATED_CHILREN).pipe(
    switchMap(({ payload }) => {
      const { userId, userData, canMasquerade } = payload;
      return services.getRelatedChildren$(userId).pipe(
        switchMap(response => {
          const childrenWithYouthPositions = response.filter(
            child => !adultPositionsForParticipant.includes(child.position),
          );
          const childs = of([]);
          return forkJoin(childs).pipe(
            mergeMap(() => {
              const extraOrgs = getOrganizationsFromChildren({
                myScout: childrenWithYouthPositions,
              });
              const newOrganizations = removeEmptyOrganizations([
                ...removeParentGuardiansFromOrganizations(
                  userData.organizations,
                ),
                ...extraOrgs,
              ]);
              return concat(
                of(
                  continueLogin({
                    userData: {
                      ...userData,
                      organizations: newOrganizations,
                    },
                    canMasquerade,
                  }),
                ),
                // myScout response
                of(addChildren(extraOrgs)),
                of(triggerAllRostersRequest(true)),
              );
            }),
            catchAndReport(() => {
              // continue login even if some youth request fail
              const newUserData = {
                ...userData,
              };
              if (!SBL_4832_EXPIRED_MEMBERSHIP_ACCESS) {
                newUserData.organizations =
                  removeParentGuardiansFromOrganizations(
                    userData.organizations,
                  );
              }
              return of(
                continueLogin({ userData: newUserData, canMasquerade }),
              );
            }),
          );
        }),
      );
    }),
  );

export default combineEpics(fetchRelatedChildrenEpic$);
